import React, { useContext, useEffect } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import {
    CustomerAreaContext,
    CustomerAreaProvider,
    PAGES,
} from "./CustomerAreaProvider";
import {
    Overview,
    Login,
    EditProfile,
    EditPassword,
    OrdersOverview,
    OrderDetail,
} from "./sections";
import isEmpty from "lodash.isempty";
import { viewPage } from "~/assets/js/Api/eventsApi";
import { CartProvider } from "~/assets/js/global/cartContext";

const CustomerArea = () => {
    const { state: CustomerAreaState } = useContext(CustomerAreaContext);

    useEffect(() => {
        setTimeout(() => viewPage(document.title), 500);
    }, []);

    const renderPage = (state) => {
        const { page, user, selectedOrder } = state;

        if (isEmpty(user)) {
            return <Login />;
        }

        switch (page) {
            case PAGES.ORDER_DETAIL:
                if (selectedOrder) {
                    return <OrderDetail />;
                }
                return <OrdersOverview />;
            case PAGES.ORDERS_OVERVIEW:
                return <OrdersOverview />;
            case PAGES.ADDRESS:
                return <div>Addresses</div>;
            case PAGES.PROFILE:
                return <EditProfile />;
            case PAGES.PASSWORD:
                return <EditPassword />;
            case PAGES.OVERVIEW:
            default:
                return <Overview />;
        }
    };

    return (
        <div
            className={`container customer-area ${
                isEmpty(CustomerAreaState.user) ? "" : "customer-area__wrapper"
            }`}
        >
            {renderPage(CustomerAreaState)}
        </div>
    );
};

const CustomerAreaApp = () => {
    return (
        <>
            <CartProvider>
                <Header />
                <CustomerAreaProvider>
                    <CustomerArea />
                </CustomerAreaProvider>
                <Footer />
            </CartProvider>
        </>
    );
};

export default CustomerAreaApp;
